import type { TFunction } from 'i18next';

import type { ActionMenuItem } from '../../components/ActionMenu';

/**
 * The four moves of a game's menu, the same on the desktop tiles and the phone rows. `index` is the game's
 * position in the whole list and `total` its length, so "Move to bottom" lands past the games not rendered
 * yet; the ends disable the moves that would go nowhere. With `onRemove`, "Remove from list" follows them: the
 * way a game the catalogue no longer holds is taken out of one of the owner's lists.
 */
export const gameMoveItems = (
  t: TFunction,
  id: string,
  index: number,
  total: number,
  onMove: (id: string, to: number) => void,
  onRemove?: (id: string) => void,
): ActionMenuItem[] => {
  const last = total - 1;
  return [
    { label: t('Move to top'), disabled: index === 0, onSelect: () => onMove(id, 0) },
    { label: t('Move up'), disabled: index === 0, onSelect: () => onMove(id, index - 1) },
    { label: t('Move down'), disabled: index >= last, onSelect: () => onMove(id, index + 1) },
    { label: t('Move to bottom'), disabled: index >= last, onSelect: () => onMove(id, last) },
    ...(onRemove
      ? [{ label: t('Remove from list'), icon: 'trash' as const, destructive: true, onSelect: () => onRemove(id) }]
      : []),
  ];
};
